import { useEffect, useState } from "react";
import styles from "./CountryCityHero.module.css";

const DEFAULT_STATS = [
  { value: "100+", label: "Destinations" },
  { value: "500+", label: "Successful Trips" },
  { value: "40+", label: "Partners" },
  { value: "10+", label: "Years Of Experience" },
];

const SLIDE_INTERVAL_MS = 5000;

function HeroVideo({ videoUrl = "", alt = "" }) {
  if (!videoUrl) return null;

  return (
    <video
      className={`standard-heroimg ${styles.heroVideo}`}
      src={videoUrl}
      autoPlay
      muted
      loop
      playsInline
      controls={false}
      controlsList="nodownload noplaybackrate noremoteplayback"
      disablePictureInPicture
      aria-label={alt || "Destination video"}
    />
  );
}

function HeroImageSlide({ image, isActive = true }) {
  if (!image?.url) return null;

  return (
    <img
      src={image.url}
      alt={image.alt || "Destination banner"}
      className={`standard-heroimg ${styles.heroImage}`}
      aria-hidden={!isActive}
    />
  );
}

function HeroImages({ images = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return undefined;

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, SLIDE_INTERVAL_MS);

    return () => clearInterval(timer);
  }, [images.length]);

  if (!images.length) return null;

  if (images.length === 1) {
    return <HeroImageSlide image={images[0]} />;
  }

  return (
    <div className={styles.carousel} aria-live="polite">
      {images.map((image, index) => (
        <div
          key={image.id || `${image.url}-${index}`}
          className={`${styles.carouselSlide} ${
            index === activeIndex ? styles.carouselSlideActive : ""
          }`}
        >
          <HeroImageSlide
            image={image}
            isActive={index === activeIndex}
          />
        </div>
      ))}
    </div>
  );
}

export default function CountryCityHero({ hero = null, stats = DEFAULT_STATS }) {
  if (!hero) return null;

  const hasVideo = hero.mode === "video" && hero.videoUrl;
  const hasImages = hero.mode === "image" && hero.images?.length > 0;

  if (!hasVideo && !hasImages) return null;

  return (
    <section className={styles.heroSection} aria-label="Destination hero">
      <div className={styles.heroMediaWrap}>
        {hasVideo ? (
          <HeroVideo videoUrl={hero.videoUrl} alt={hero.alt} />
        ) : (
          <HeroImages images={hero.images} />
        )}
      </div>

      <div className={styles.statsBar}>
        {stats.map((item) => (
          <div key={item.label} className={styles.statItem}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
